import { render, staticRenderFns } from "./SurgeryReservationListAttachment.vue?vue&type=template&id=2bd64c86&scoped=true"
import script from "./SurgeryReservationListAttachment.vue?vue&type=script&lang=js"
export * from "./SurgeryReservationListAttachment.vue?vue&type=script&lang=js"
import style0 from "./SurgeryReservationListAttachment.vue?vue&type=style&index=0&id=2bd64c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd64c86",
  null
  
)

export default component.exports